export default __webpack_public_path__ + "media/top-bg.e20383fa.png";